import { useCallback } from 'react';
import { AppState, useAppState } from './app-state';

export enum SessionStorageKeys {
  IsExpanded = 'chatWidgetIsExpanded',
}

export function useSessionStorage<T>(key: SessionStorageKeys) {
  const { appState }: { appState: AppState } = useAppState();
  const chatroomId = appState.chatroomId;

  const getValue = useCallback((): T | undefined => {
    try {
      const item =
        typeof window !== 'undefined'
          ? window.sessionStorage.getItem(`${key}-${chatroomId || 'default'}`)
          : null;
      return item ? JSON.parse(item) : undefined;
    } catch (error) {
      console.warn(`Error reading sessionStorage key "${key}":`, error);
      return undefined;
    }
  }, [chatroomId, key]);

  const setValue = useCallback(
    (value: T | ((val: T | undefined) => T)) => {
      try {
        const valueToStore =
          value instanceof Function ? value(getValue()) : value;
        if (typeof window !== 'undefined') {
          window.sessionStorage.setItem(
            `${key}-${chatroomId || 'default'}`,
            JSON.stringify(valueToStore),
          );
        }
      } catch (error) {
        console.warn(`Error setting sessionStorage key "${key}":`, error);
      }
    },
    [getValue, key, chatroomId],
  );

  return { getValue, setValue } as const;
}
